import LocationField from "kinnect-front/Locations/LocationField";
import VendorField from "kinnect-front/FacilityMaintenance/Vendors/VendorField";
import {
	FacilityMaintenanceVendor,
	Location
} from "kinnect-models";
import { FetchesData } from "kinnect-mixins";
import {
	KForm,
	KPhoneField,
	KTextField,
	KTextarea
} from "kinnect-general";
import { VSwitch } from "vuetify/lib";

export default KForm.extend( {
	name: "FacilityMaintenanceContactForm",

	props: {
		contact: Object,

		redirect: {
			...KForm.options.props.redirect,
			default: () => [ "back", { name: "facilityMaintenanceContacts" } ]
		}
	},

	mixins: [ FetchesData ],

	data: () => ( {
		formFields: {
			email: null,
			idVendor: null,
			isPreferredContactMethod: false,
			locations: [],
			name: null,
			notes: null,
			phone: null
		},
		locations: [],
		vendors: []
	} ),

	computed: {
		editing() {
			return Boolean( this.contact );
		},

		formUrl() {
			return this.editing
				? `facility-maintenance/contacts/${this.contact.id}`
				: "facility-maintenance/contacts";
		}
	},

	watch: {
		contact: {
			handler( contact ) {
				if ( contact ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( contact.hasOwnProperty( key )
							&& key !== "locations"
						) {
							this.formFields[key] = contact[key];
						}
					} );

					this.formFields.locations = contact.locations.map( item => item.id );
				}
			},
			immediate: true
		}
	},

	methods: {
		onCreateVendor( vendor ) {
			this.vendors.push( vendor );
			this.formFields.idVendor = vendor.id;
		},

		onCreateLocation( location ) {
			this.locations.push( location );
			this.formFields.locations.push( location.id );
		},

		async fetchVendors() {
			this.vendors = await FacilityMaintenanceVendor.get();
		},

		async fetchLocations() {
			this.locations = await Location.get();
		},

		async fetch() {
			await this.$http.all( [
				this.fetchVendors(),
				this.fetchLocations()
			] );
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post"
			}}
			on={this.$listeners}
		>
			<KTextField
				label="Name*"
				prependIcon="person"
				required
				vModel={this.formFields.name}
				validationName="name"
				validationRules="required"
			></KTextField>

			<VendorField
				items={this.vendors}
				label="Vendor*"
				loading={this.$wait.is( "get vendors" )}
				onCreate={this.onCreateVendor}
				required
				showAddButton={this.$can( "add_facility_maintenance_vendors" )}
				vModel={this.formFields.idVendor}
				validationId="idVendor"
				validationName="vendor"
				validationRules="required"
			></VendorField>

			<LocationField
				chips
				deletableChips
				items={this.locations}
				label="Location(s)*"
				loading={this.$wait.is( "get locations" )}
				multiple
				onCreate={this.onCreateLocation}
				required
				showAddButton={this.$can( "add_locations" )}
				vModel={this.formFields.locations}
				validationName="location(s)"
				validationId="locations"
				validationRules="required"
			></LocationField>

			<KPhoneField
				label="Phone Number"
				vModel={this.formFields.phone}
				validationName="phone"
				validationRules="phone"
			></KPhoneField>

			<KTextField
				label="Email"
				prependIcon="email"
				type="email"
				vModel={this.formFields.email}
				validationName="email"
				validationRules="email"
			></KTextField>

			<KTextarea
				label="Notes"
				prependIcon="comment"
				vModel={this.formFields.notes}
			></KTextarea>

			<VSwitch
				color="accent"
				falseValue={false}
				inputValue={this.formFields.isPreferredContactMethod}
				inset
				label="Is Preferred Vendor Contact Method"
				onChange={val => this.formFields.isPreferredContactMethod = val}
				trueValue={true}
			></VSwitch>
		</KForm>;
	}
} );
